export const TOPIC_OPTIONS = [
  { key: 'sports', label: 'Sports', group: 'Core' },
  { key: 'football', label: 'Football', group: 'Core' },
  { key: 'music', label: 'Music', group: 'Culture' },
  { key: 'movies', label: 'Movies', group: 'Culture' },
  { key: 'tech', label: 'Tech', group: 'Core' },
  { key: 'gaming', label: 'Gaming', group: 'Culture' },
  { key: 'memes', label: 'Memes', group: 'Culture' },
  { key: 'relationships', label: 'Relationships', group: 'Life' },
  { key: 'school', label: 'School', group: 'Life' },
  { key: 'money', label: 'Money', group: 'Life' },
  { key: 'fashion', label: 'Fashion', group: 'Culture' },
  { key: 'food', label: 'Food', group: 'Life' },
  { key: 'world', label: 'World', group: 'Core' },
  { key: 'life', label: 'Life', group: 'Life' },
];

export const PRIMARY_TOPIC_KEYS = ['sports', 'football', 'music', 'tech', 'memes'];
export const TOPBAR_TOPIC_KEYS = ['sports', 'football', 'tech', 'music'];

export const TOPIC_STYLES = {
  sports: { bg: '#FEE2E2', color: '#B91C1C' },
  football: { bg: '#DCFCE7', color: '#166534' },
  music: { bg: '#FCE7F3', color: '#BE185D' },
  movies: { bg: '#EDE9FE', color: '#6D28D9' },
  tech: { bg: '#DBEAFE', color: '#1D4ED8' },
  gaming: { bg: '#ECFCCB', color: '#3F6212' },
  memes: { bg: '#FEF3C7', color: '#92400E' },
  relationships: { bg: '#FFE4E6', color: '#BE123C' },
  school: { bg: '#E0F2FE', color: '#0369A1' },
  money: { bg: '#DCFCE7', color: '#15803D' },
  fashion: { bg: '#FAE8FF', color: '#A21CAF' },
  food: { bg: '#FFEDD5', color: '#C2410C' },
  world: { bg: '#E2E8F0', color: '#334155' },
  life: { bg: '#F1F5F9', color: '#475569' },
  default: { bg: '#EEF2F7', color: '#475569' },
};

export const POST_TYPE_OPTIONS = [
  { key: 'quick', label: 'Quick Pick', description: 'Fast casual choice' },
  { key: 'take', label: 'Opinion', description: 'Personal point of view' },
  { key: 'hot', label: 'Hot Topic', description: 'Built to split the room' },
  { key: 'thought', label: 'Open Thought', description: 'Discussion-first thought' },
];

export const DEFAULT_USER_SETTINGS = {
  privacy: {
    publicProfile: true,
    showFollowers: true,
    showFollowing: true,
    showLockHistory: true,
    showOpinionPassport: true,
    allowDiscovery: true
  },
  preferences: {
    theme: 'system',
    feedDensity: 'comfortable',
    defaultPostType: 'take',
    preferredTopics: ['sports', 'football', 'tech'],
    mutedTopics: []
  },
  notifications: {
    comments: true,
    replies: true,
    followers: true,
    heat: true,
    weeklyRecap: true,
    productUpdates: false
  }
};
